import React from "react";
import { Modal, Typography, Image, Button } from "antd";
import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
import CustomBadge from "../Charts/CustomBadge";
import { useSelector } from "react-redux";

const { Title } = Typography;

const ViewBrochureModal = ({ isOpen, closeModal, data }) => {
  const { is_customer } = useSelector((state) => state.auth);
  const title = data?.name || data?.brochure_name || "Brochure Details";
  const status = data?.status || "Disabled";

  return (
    <Modal
      open={!!isOpen}
      onCancel={closeModal}
      destroyOnHidden
      width={500}
      footer={null}
      className="form-css-5"
      closable={true}
    >
      <div className="mb-6">
        <Title level={2} className="font-abhaya !mb-0 text-3xl text-gray-800 pe-5" title={title}>
          {title}
        </Title>
        {!is_customer && (
          <CustomBadge variant={status === "Active" ? "success" : "danger"} text={status} />
        )}
      </div>

      <div className="flex flex-col gap-6">
        <div className="w-full flex justify-center bg-gray-50 rounded-xl border border-gray-200 p-2">
          {data?.brochure_picture_url ? (
            <img
              src={data.brochure_picture_url}
              alt="Brochure Cover"
              className="w-full h-auto rounded-lg shadow-sm"
            />
          ) : (
            <div className="h-[200px] flex items-center justify-center text-gray-400">
              No Cover Image Available
            </div>
          )}
        </div>

        <div className="w-full bg-[#FBEEEC] rounded-xl p-4 flex items-center justify-between border border-[#f5d5d0]">
          <div className="flex items-center gap-3 overflow-hidden">
            <div className="bg-[#A33434] p-2.5 rounded-lg text-white flex items-center justify-center">
              <FilePdfOutlined className="text-2xl" />
            </div>
            <div className="flex flex-col truncate pr-2">
              <span className="font-semibold text-gray-800 truncate" title={data?.brochure_pdf}>
                {data?.brochure_pdf || "Brochure_Document.pdf"}
              </span>
              <span className="text-xs text-gray-500 font-medium">PDF Document</span>
            </div>
          </div>

          <div className="flex gap-2 shrink-0">
            <Button
              type="default"
              shape="circle"
              icon={<DownloadOutlined />}
              href={data?.brochure_pdf_url}
              target="_blank"
              disabled={!data?.brochure_pdf_url}
              className="border-gray-300 text-gray-600 hover:!text-[#A33434] hover:!border-[#A33434]"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewBrochureModal;